exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stock-wh-trigger[data-v-7a2fa2d4]{cursor:help}.stock-wh-content[data-v-7a2fa2d4]{min-width:180px}.stock-wh-product+.stock-wh-product[data-v-7a2fa2d4]{margin-top:8px;padding-top:8px;border-top:1px solid #eee}.stock-wh-product-name[data-v-7a2fa2d4]{font-weight:600;margin-bottom:4px}.stock-wh-list[data-v-7a2fa2d4]{list-style:none;margin:0;padding:0}.stock-wh-list li[data-v-7a2fa2d4]{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:2px 0}.stock-wh-list .stock-wh-name[data-v-7a2fa2d4]{font-size:12px}.stock-wh-list .stock-wh-unassigned .stock-wh-name[data-v-7a2fa2d4]{font-style:italic;color:#9a6b00}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7a2fa2d4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"silenceDeprecations":["legacy-js-api","import","global-builtin","color-functions","slash-div"],"quietDeps":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Global/StockByWarehousePopover.vue
// module id = 936
// module chunks = 0